import React, { useContext } from 'react'

import { ThemeContext } from '../../contexts'
import { FiSun, FiMoon } from 'react-icons/fi'
import './style.scss'

const ThemedButton = () => {
  const { switchTheme, isSwitched } = useContext(ThemeContext)

  return (
    <div>
      {isSwitched ? (
        <FiSun
          onClick={switchTheme}
          className="grow-icon animate-appear"
          aria-hidden="true"
          title="Light mode"
        />
      ) : (
        <FiMoon
          onClick={switchTheme}
          className="grow-icon animate-appear"
          aria-hidden="true"
          title="Dark mode"
        />
      )}
    </div>
  )
}
export default ThemedButton
